import React, { PropsWithChildren } from 'react';
import { Link, LinkProps } from 'react-router-dom';

const AppLink: React.FC<PropsWithChildren<LinkProps>> = ({ children, ...props }) => (
  <Link {...props} to={`${props.to}`}>
    {children}
  </Link>
);

export default AppLink;
